// FUNCTION FOR CAPITALIZING STRING

export function Capitalize (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }